import { VehicleAssessment } from "../../../system/Domain";
import ListItemChip from "../../../Components/ListItemChip";

interface Props {
	vehicleAssessment: VehicleAssessment
}

const SpecialMarkerChips = (props: Props) => {
	if (props.vehicleAssessment.markers?.isSpecialCase !== true) {
		return <></>;
	}

	return (
		<>
			{props.vehicleAssessment.markers.highTotal && (
				<ListItemChip label="Zu hohe Schadenssumme" key="highTotal" color="warning" />
			)}
			{props.vehicleAssessment.markers.highDamagePosition && (
				<ListItemChip label="Zu hohe Einzelposition" key="highDamagePosition" color="warning" />
			)}
			{props.vehicleAssessment.markers.manyPositions && (
				<ListItemChip label="Zu viele Schadenspositionen" key="manyPositions" color="warning" />
			)}
		</>
	);
};

export default SpecialMarkerChips;
